// Tiny logger wrapper so we can silence dev-time `console.log` calls in
// production without sweeping the codebase every time. Errors still pass
// through so monitoring / Sentry-style integrations can hook them.
//
// Usage:
//   import { logger } from "../../utill/logger";
//   logger.log("fetched", res);
//   logger.error("API failed", err);

const isProd = process.env.NODE_ENV === "production";

/* eslint-disable no-console */
export const logger = {
  log: isProd ? () => {} : console.log.bind(console),
  warn: isProd ? () => {} : console.warn.bind(console),
  // Errors always surface — they're the signal we want in prod, just routed
  // through this wrapper so a future integration (Sentry, Datadog) has one
  // place to plug in.
  error: console.error.bind(console),
};
/* eslint-enable no-console */
